import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { isCapacitorPlatform } from "@src/appV2/lib";
import { openNativeSettings } from "@src/appV2/lib/NativeSettings/native-settings";
import { useCallback } from "react";

import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";

export interface NotificationSettingsBottomSheetProps {
  modalState: UseModalState;
}

export function NotificationSettingsBottomSheet(props: NotificationSettingsBottomSheetProps) {
  const { modalState } = props;

  const onGoToSettings = useCallback(() => {
    modalState.closeModal();

    if (isCapacitorPlatform()) {
      void openNativeSettings({ option: "settings" });
    }
  }, [modalState]);

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth onClick={onGoToSettings}>
            Go to settings
          </Button>
          <Button fullWidth variant="outlined" onClick={modalState.closeModal}>
            Cancel
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        hasFooter
        illustrationType="mobile-phone"
        title="Enable push notifications"
        description="Please go to settings to allow Clipboard to send you push notifications"
      />
    </BottomSheet>
  );
}
